import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Select } from '@ngxs/store';
import { ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'serviceos-web-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  @Select(ModulesSelectors.getModuleConfigText('auth'))
    moduleAuthTexts$!: Observable<any>;

  @Output()
  public changeScreenEvent = new EventEmitter();

  @Input()
  public screen = 'login';

  constructor() { }

  ngOnInit(): void {
  }

  public changeScreen(screen) {
    this.changeScreenEvent.next(screen);
  }

}
